<template>
  <div class="go-in">
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="section-summary">
          <div class="container">
            <div class="main">
              <div class="title">电商价格数据监测/品牌商品控价系统</div>
              <div class="kuangcontent">
                线上渠道的定价监管是很多品牌面临的一个问题，如何做好电商渠道管理？
                我们通过跟多家品牌的合作以及数据技术沉淀，推出了电商价格监测系统，主要有以下特点：
                <br />
                <ul>
                  <li>监控的商城全：京东、天猫、淘宝、拼多多、抖音、苏宁、国美、唯品会等50余家电商数据；</li>
                  <li>监测的价格准：不仅仅是商城面价，还包含活动后的价格（优惠券，满减等），图片上的价格识别；</li>
                  <li>价格监测频率：根据你的需求来配置；</li>
                  <li>智能数据绑定：比价最核心的是要对全网的数据进行同款绑定，绑定的准确率直接影响比价效果
                    ，这正是我们擅长的，上下架、改标题、规格不一致等问题我们都有解决方案；</li>
                  <li>破价提醒机制：超出设定的价格范围就提醒（或价格波动提醒）；</li>
                  <li>数据图表可视化：对监控和破价数据分析生成报告，以可视化图表显示，并可通过Excel灵活导出；</li>
                  <li>数据灵活运用：通过API对接输出数据（主要是已绑定的价格信息），合作方将数据应用在自身平台；</li>
                </ul>
                ...
                <br />
                目前已经跟多家品牌商、采购商进行此类合作，形成了较为完善的解决方案，帮助合作方节省了开发投入。
                <br />
                合作费用：主要依据商品数量和需要的商城数，是否需要智能绑定报价。
                <h2 style="margin:20px 0">合作案例</h2>
                <div style="line-height:30px;">
                  基于保密协议，我们不能公布具体的合作方名称，已经为以下类型企业提供解决方案：
                  <br />
                  多个知名家电品牌的渠道管理，多个知名消费品牌的乱价管控，
                  多个大型国有企业的采购比价，多家知名电商平台的定价参考等。
                </div>
                <h2 style="margin:20px 0">应用场景</h2>
                <div class="box">
                  <b>品牌方</b>
                  <br />
                  为品牌方提供7*24小时监控产品网络销售价格，低价乱价实时预警；高效管理产品销售渠道，建立稳固的渠道价格体系，降低管理成本。
                </div>
                <div class="box">
                  <b>自有商城</b>
                  <br />
                  为企业自建商城提供精准的定价策略指导，建立价格分析和优化体系，实现对大量SKU的精细化和高效率的价格管理。
                </div>
                <div class="box">
                  <b>电商运营</b>
                  <br />
                  实时监测竞品价格动态，生成竞品分析报表，深入了解竞品主要营销方式与运营优势，扬长避短合理制定合理的销售目标和运营计划。
                </div>
                <div class="box">
                  <b>政企供应商</b>
                  <br />
                  分析竞品在不同渠道的价格弹性，基于产品历史销售特点，动态决策最优价格，制定产品供应价格优化策略，实现收入最大化。
                </div>
                <div class="box">
                  <b>政企采购</b>
                  <br />
                  避免在采购过程中受到厂家与经销商的制约出现价格虚高、特供型号无法比价、价格与市场不同步、缺乏监督等重点问题，确保采购过程公平公正、有效节约资金。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    // swiper,
    // swiperSlide
  },
  data() {
    return {
      loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  mounted() {
    this.loading = false
    // this.$http
    //   .all([
    //     this.$http.get("Honor/GetHonorAll"),
    //     this.$http.get("Enterprise/GetEnterpriseAll"),
    //     this.$http.get(`Team/GetTeamAll`),
    //     this.$http.get(`Course/GetCourseAll`)
    //   ])
    //   .then(
    //     this.$http.spread(
    //       (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
    //         this.honorList = responseHonor.data;
    //         this.partnerImg = responseEnterprise.data;
    //         this.teamItem = responseTeam.data;

    //         var groupCount = Math.ceil(responseCourse.data.length / 2);
    //         window.console.log(groupCount);
    //         for (let i = 0; i < groupCount; i++) {
    //           let img2 = [];
    //           for (let j = 0; j < 2; j++) {
    //             if (responseCourse.data.length - 1 >= i * 2 + j) {
    //               img2.push(responseCourse.data[i * 2 + j]);
    //             }
    //           }
    //           this.courseList.push(img2);
    //         }
    //         window.console.log(this.courseList);
    //         this.loading = false;
    //       }
    //     )
    //   );
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
  position: relative;
  overflow: hidden;
  background-color: #eee;

  .section {
    width: 100%;
    background-color: #eee;

    &-content {
      width: 994px;
      margin: 0 auto;
      background-color: #fff;
      // background-color: #eee;

      .section-summary {
        margin-top: 20px;

        .container {
          width: 968px;
          margin: 0px auto;
          text-align: center;
          min-height: 1150px;

          .main {
            // border: 1px solid #eee;
            width: 968px;
            // background-color: #fff;
            margin: 30px 0px;
            padding: 20px 0;

            .title {
              margin-left: 30px;
              margin-top: 30px;
              font-size: 22px;
              font-weight: bold;
              text-align: left;
              color: #000;
            }

            .kuangcontent {
              margin: 40px;
              font-size: 14px;
              line-height: 30px;
              text-align: left;
              color: #333333;

              .box {
                float: left;
                width: 260px;
                height: 160px;
                border: 1px solid #eee;
                padding: 10px;
                margin-right: 10px;
                margin-bottom: 10px;
                font-size: 14px;
              }
            }


          }
        }
      }

      // .content-summary {
      //   //height: 500px;
      //   display: flex;
      //   justify-content: space-around;
      //   padding: 100px 0;
      //   .summary-left {
      //     width: 600px;
      //     .title {
      //       font-size: 25px;
      //       color: #e13834;
      //     }
      //     .eTitle {
      //       font-size: 17px;
      //       color: #e13834;
      //       padding: 20px 0;
      //     }
      //     .content {
      //       color: #14679f;
      //       font-size: 14px;
      //       text-indent: 25px;
      //       line-height: 30px;
      //     }
      //   }

      //   .summary-right {
      //     width: 400px;
      //     height: 310px;
      //     border: 2px solid #1d42b9;
      //     //animation: imgboxkey 4s infinite;
      //     border-radius: 10px;
      //     margin-top: 80px;
      //     text-align: center;

      //     img {
      //       width: 360px;
      //       height: 270px;
      //       margin-top: 20px;
      //       //animation: imgbo 4s infinite;
      //     }
      //   }
      // }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }

  40% {
    border: solid rgb(255, 255, 255) 2px;
  }

  60% {
    border: solid rgb(255, 255, 255) 2px;
  }

  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }

  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }

  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}

.el-divider--horizontal {
  margin: 1px 0;
}

.top {

  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }

  h3 {
    font-size: 30px;
  }

  p {
    font-size: 20px;
  }

  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}

// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}

.order-top {
  order: 1;
}

.el-divider {
  background-color: red;
  height: 3px;

  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}

.el-divider-active {
  background-color: #3c6088;
}

.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;

  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;

      img {
        width: 100%;
      }
    }
  }
}
</style>